export default {
  container: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'start',
    gridColumnGap: '5px'
  }
};